<div class="d-flex align-items-center logo-padding">
	<app-main-logo class="cursor-pointer" routerLink="/" imgHeight="40"></app-main-logo>
</div>

<div>
	<button
		class="btn btn-outlined-grey mr-4"
		[routerLink]="componentsOverviewRoute"
		*ngIf="isComponentsOverviewAvailable"
	>
		Components overview
	</button>
	<ng-container *ngIf="isOrganizationPickerAllowed">
		<app-organization-picker [organizations]="organizations"></app-organization-picker>

		<span>|</span>
	</ng-container>

	<ng-container *ngIf="isNotificationsAllowed">
		<app-alerts [allowedOrganizationsArray]="organizations"></app-alerts>

		<span>|</span>
	</ng-container>

	<div dropdown>
		<div dropdownToggle>
			<span [title]="userName" data-test-id="user-name-header-menu">{{ userName }}</span>
			<img src="/assets/icons/sidebar-organization-picker-arrow.png" alt="Arrow Down" />
		</div>
		<div class="dropdown-menu dropdown-menu-right sidebar-dropdown" *dropdownMenu>
			<div class="dropdown-header text-center">{{ userRole }}</div>

			<div class="dropdown-item" [routerLink]="appRouteHelper.userProfile">
				<span>User Profile</span>
			</div>

			<ng-container *ngIf="isPresentationModeAllowed || isNotificationsAllowed">
				<div class="dropdown-divider"></div>

				<div class="dropdown-item" *ngIf="isPresentationModeAllowed" (click)="togglePresentMode()">
					<span data-test-id="toggle-present-mode">Toggle Present Mode</span>
				</div>
				<div [routerLink]="appRouteHelper.notificationManagement" *ngIf="isNotificationsAllowed" class="dropdown-item">
					<span>Notification Management</span>
				</div>
			</ng-container>

			<div class="dropdown-item organization-box">
				<span>
					<span>Organization ID:</span>
					<span>{{ organizationId }}</span>
				</span>

				<app-clipboard-copy [text]="organizationId" [outlineView]="true"></app-clipboard-copy>
			</div>

			<div class="dropdown-item" (click)="logout()" data-test-id="logout-button"><span>Log Out</span></div>
		</div>
	</div>
</div>
